import React, { PropTypes } from 'react';
import { Svg, G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function SuccessIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <Svg {...svgProps}
      viewBox="0 0 30 30"
    >


      <G id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="Step-8:Success" transform="translate(-271.000000, -395.000000)">
          <G id="Group-6" transform="translate(250.000000, 334.000000)">
            <G id="tick" transform="translate(21.000000, 61.000000)">
              <Path d="M22.3662648,10.846567 L13.3045359,19.8672542 L9.19217673,15.7737549 C9.04990572,15.6326532 8.81988361,15.6326532 8.67813183,15.7737549 C8.53586082,15.9153734 8.53586082,16.1443406 8.67813183,16.2854423 L13.0475135,20.6347853 C13.1181298,20.7055945 13.2115925,20.7407407 13.3045359,20.7407407 C13.3974794,20.7407407 13.4904229,20.7055945 13.5615584,20.6347853 L22.8803097,11.3582544 C23.0225807,11.2171527 23.0225807,10.9876687 22.8803097,10.846567 C22.738558,10.7054653 22.5080166,10.7054653 22.3662648,10.846567" id="Fill-390" fill= { color ? color : "#FBFBFA" }></Path>
              <Path d="M25.7268468,24.4191267 C23.2105932,27.285441 19.7293285,28.9996548 15.9239852,29.246386 C12.1222543,29.4920848 8.44489108,28.2429437 5.57927252,25.7260793 C2.71365395,23.2086987 0.999856139,19.7260728 0.7526688,15.9198057 C0.506513559,12.1135387 1.75638357,8.43889598 4.2731532,5.57258177 C7.09129528,2.36301186 11.0401001,0.722094723 15.0085148,0.722094723 C18.3550908,0.722094723 21.7156001,1.88916413 24.4212435,4.26614539 C27.286346,6.78300979 29.0001439,10.2656358 29.2468152,14.0719028 C29.4934864,17.878686 28.2436164,21.5533287 25.7268468,24.4191267 M29.9677352,14.0254471 C29.7086788,10.026131 27.9081848,6.36748973 24.8980726,3.72313034 C18.6832978,-1.73540968 9.1874852,-1.1196141 3.72975389,5.095637 C1.08603628,8.1069961 -0.227307727,11.9674614 0.0322647813,15.9667775 C0.291321241,19.9655775 2.09181524,23.6242188 5.1024435,26.2685782 C7.86330417,28.6940798 11.3378602,30 14.978584,30 C15.3083391,30 15.6386103,29.9891603 15.9704296,29.967481 C19.9687751,29.7083617 23.6265285,27.9069144 26.2702461,24.8960715 C28.9139637,21.8847124 30.2273077,18.0242471 29.9677352,14.0254471" id="Fill-391" fill={ color ? color : "#FFFFFF" }></Path>
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
}

// SuccessIcon.propTypes = {
//   height: PropTypes.number,
//   width: PropTypes.number,
//   color: PropTypes.string,
// };

// SuccessIcon.defaultProps = {
//   height: 16,
//   width: 16,
// };

export default pure(SuccessIcon);
